import styled from "styled-components";
import { Row } from "../../../components/flex/styled";

export const ReferYourEmployerWrapper = styled(Row)(() => {
  return {
    gap: 0,
    minHeight: "100vh",
    "& .refer-text": {
      flex: 1,
      overflow: "hidden",
      padding: "calc(var(--cardPadding) * 2)",
      backgroundColor: "#286c2b",
      color: "#FFFFFF",
      minHeight: "100%",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
    },
    "& .refer-form": {
      flex: 1,
      backgroundColor: "var(--color-background)",
      padding: "calc(var(--cardPadding) * 2)",
      overflow: "hidden",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      "& h1": {
        margin: 0,
      },
      "& p": {
        margin: 0,
      },
    },
    "& form": {
      display: "flex",
      flexDirection: "column",
      gap: "calc(var(--flexGap) * 1.5)",
      marginBlock: "calc(var(--sectionMargin))",
      overflow: "hidden",
    },
    "& .refer-text>svg": {
      width: "100%",
      height: "auto",
    },
    "& .refer-form fieldset": {
      flex: 1,
      overflow: "hidden",
      display: "flex",
      gap: "calc(var(--flexGap)/8)",
      flexDirection: "column",
      justifyContent: "space-between",
    },
    "& .refer-form label": {
      fontFamily: "Poppins",
      fontWeight: 500,
      color: "var(--color-text)",
    },
    "& .refer-form input": {
      padding: "calc(var(--cardPadding) / 3) calc(var(--cardPadding) /2)",
      outline: "none",
      border: "1px solid var(--color-primary-hover)",
      backgroundColor: "var(--color-button-secondary)",
      fontWeight: 400,
      borderRadius: "8px",
    },
    "& .refer-text > div: last-child": {
      flex: 1,
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
    },
    "@media screen and (max-width: 425px)": {
      "& .refer-text": {
        padding: "calc(var(--cardPadding))",
      },
      "& .refer-form": {
        padding: "calc(var(--cardPadding))",
      },
    },
    "@media screen and (max-width: 1024px)": {
      "& h1": {
        marginBlock: 0,
      },
      "& form": {
        gap: "var(--flexGap)",
      },
      "& .logo-box-area": {
        maxWidth: "50%",
        marginBlockEnd: "0",
        "& svg": {
          width: "100%",
          height: "auto",
        },
      },
    },
  };
});

export const ReferYourEmployerRow = styled(Row)(() => {
  return {
    "@media screen and (max-width: 768px)": {
      flexDirection: "column",
    },
  };
});
